var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 114,
    viewBox: "0 0 124 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.4989 74.8039C57.3635 64.1095 72.5498 64.2875 76.1627 75.0695L80.8307 88.9998C83.4356 96.7736 77.6512 104.813 69.4525 104.813H59.7505C51.4331 104.813 45.638 96.5565 48.4648 88.7342L53.4989 74.8039Z",
    fill: "#0F1E24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2294 28.4295C57.0219 21.8459 66.8404 21.8459 71.6329 28.4295L101.689 69.7183C107.462 77.6493 101.797 88.7806 91.9871 88.7806H31.8752C22.0654 88.7806 16.4001 77.6493 22.1735 69.7183L52.2294 28.4295Z",
    fill: "#006138"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7262 19.7923C57.5253 13.3652 67.1575 13.3652 71.9566 19.7923L93.4845 48.6229C99.3939 56.5369 93.7461 67.8026 83.8693 67.8026H40.8136C30.9368 67.8026 25.289 56.5369 31.1984 48.6229L52.7262 19.7923Z",
    fill: "#019153"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9773 12.4189C56.7806 6.15478 66.2194 6.15477 71.0227 12.4189L83.5055 28.6981C89.5585 36.592 83.9304 48 73.9828 48H49.0172C39.0696 48 33.4415 36.592 39.4945 28.6981L51.9773 12.4189Z",
    fill: "#84C87F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.df21cf1c2b5d0c7dec332c70363ea989.svg";
export { ForwardRef as ReactComponent };